import { IconCalculator, IconSpeakerphone, IconDashboard, IconUser, IconFile, IconSettings, IconShoppingCartDiscount, IconBrandBlogger, IconQuestionCircle, IconInbox, IconTemplate } from '@tabler/icons';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { VerifiedUserOutlined } from '@mui/icons-material';
import { Modules } from 'store/constant';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
// constant
const icons = { IconCalculator, IconDashboard, IconUser, IconSettings, IconFile, IconShoppingCartDiscount, LocalOfferIcon, IconBrandBlogger, IconQuestionCircle, IconSpeakerphone, IconInbox , IconTemplate};
import { MODULE_KEYS } from 'store/constant';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Substation Management',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false,
      moduleId: Modules.Dashboard,
      moduleKey: MODULE_KEYS.Dashboard
    },
    {
      id: 'blog',
      title: 'Blogs',
      type: 'item',
      url: '/blog',
      icon: icons.IconBrandBlogger,
      breadcrumbs: false,
      moduleId: Modules.Blogs,
      moduleKey: MODULE_KEYS.Blogs
    },
    {
      id: 'inquiry',
      title: 'Inquiry',
      type: 'item',
      url: '/inquiry',
      icon: icons.IconQuestionCircle,
      breadcrumbs: false,
      moduleId: Modules.Inquiry,
      moduleKey: MODULE_KEYS.Inquiry
    },
    // {
    //   id: 'calculators',
    //   title: 'Calculators',
    //   type: 'item',
    //   url: '/calculators',
    //   icon: icons.IconCalculator,
    //   breadcrumbs: false,
    //   moduleId: Modules.Calculators
    // },
    {
      id: 'plan-management',
      title: 'Plan Management',
      type: 'item',
      url: '/plan-management',
      icon: icons.IconFile,
      breadcrumbs: false,
      moduleId: Modules.Subscriptions,
      moduleKey: MODULE_KEYS.Plan_Management
    },
    {
      id: 'accounts',
      title: 'Accounts',
      type: 'item',
      url: '/accounts',
      icon: icons.IconUser,
      breadcrumbs: false,
      moduleId: Modules.Accounts,
      moduleKey: MODULE_KEYS.Accounts
    },
    {
      id: 'Marketing',
      title: 'Marketing',
      type: 'collapse',
      icon: icons.IconSpeakerphone,
      breadcrumbs: false,
      moduleId: Modules.Marketing,
      moduleKey: MODULE_KEYS.Marketing,
      children: [
        {
          id: 'subscriber',
          title: 'Subscribers',
          type: 'item',
          url: '/marketing/subscriber',
          breadcrumbs: false,
          icon: icons.IconSpeakerphone,
          moduleId: Modules.Subscriber,
          moduleKey: MODULE_KEYS.Subscriber
        },
        {
          id: 'template',
          title: 'Template',
          type: 'item',
          url: '/marketing/template',
          breadcrumbs: false,
          icon: icons.IconTemplate,
          moduleId: Modules.Template,
          moduleKey: MODULE_KEYS.Template
        },
        {
          id: 'campaign',
          title: 'Campaign',
          type: 'item',
          url: '/marketing/campaign',
          breadcrumbs: false,
          icon: icons.IconTemplate,
          moduleId: Modules.Campaign,
          moduleKey: MODULE_KEYS.Campaign
        },
      ]
    },
    {
      id: 'admin-user-management',
      title: 'Admin User Management',
      type: 'item',
      url: '/admin-user-management',
      icon: AdminPanelSettingsOutlinedIcon,
      breadcrumbs: false,
      // external: true
      // target: true
      moduleId: Modules.UserManagement
    },
    {
      id: 'role-management',
      title: 'Role Management',
      type: 'item',
      url: '/role-management',
      icon: VerifiedUserOutlined,
      breadcrumbs: false,
      moduleId: Modules.RoleManagement
      // external: true
      // target: true
    },
    {
      id: 'support',
      title: 'Support',
      type: 'item',
      url: '/support',
      icon: icons.IconInbox,
      breadcrumbs: false,
      moduleId: Modules.IconHelpOff,
      moduleKey: MODULE_KEYS.Support
    },
    {
      id: 'role-management',
      title: 'Role Management',
      type: 'item',
      url: '/role-management',
      icon: VerifiedUserOutlined,
      breadcrumbs: false,
      moduleId: Modules.RoleManagement,
      moduleKey: MODULE_KEYS.Role_Management
      // external: true
      // target: true
    },
    {
      id: 'admin-user-management',
      title: 'Admin User Management',
      type: 'item',
      url: '/admin-user-management',
      icon: AdminPanelSettingsOutlinedIcon,
      breadcrumbs: false,
      // external: true
      // target: true
      moduleId: Modules.UserManagement,
      moduleKey: MODULE_KEYS.User_Management
    },
    // {
    //   id: 'coupon-management',
    //   title: 'Coupon Management',
    //   type: 'item',
    //   url: '/coupon-management',
    //   icon: icons.LocalOfferIcon,
    //   breadcrumbs: false,
    //   moduleId: Modules.CouponManagement
    // },
    // {
    //   id: 'will-management',
    //   title: 'Will Management',
    //   type: 'item',
    //   url: '/will-management',
    //   icon: icons.IconFile,
    //   breadcrumbs: false,
    //   moduleId: Modules.WillManagement
    // },
    // {
    //   id: 'subscription',
    //   title: 'Subscriptions',
    //   type: 'item',
    //   url: '/subscriptions',
    //   icon: icons.IconFile,
    //   breadcrumbs: false,
    //   moduleId: Modules.Subscriptions
    // },
    // {
    //   id: 'system-configuration',
    //   id: 'system-configuration',
    //   title: 'System Configuration',
    //   type: 'item',
    //   url: '/system-configuration',
    //   icon: icons.IconSettings,
    //   breadcrumbs: false,
    //   // external: true
    //   // target: true
    //   moduleId: Modules.SystemConfiguration
    // },
    // {
    //   id: 'contact',
    //   title: 'My Contact',
    //   type: 'item',
    //   url: '/contact',
    //   icon: icons.IconUser,
    //   breadcrumbs: false,
    //   moduleId: Modules.CustomerManagement
    // }
  ]
};

export default dashboard;
